import {
  RECEIVED_VOUCHERS_REQUEST,
  RECEIVED_VOUCHERS_SUCCESS,
  RECEIVED_VOUCHERS_ERROR,
  RECEIVED_VOUCHERS_CLEAR,
} from '../types/receivedVouchersTypes';

const initialState = {
  comprobantes: [],
  page: 0,
  size: 15,
  totalElements: 0,
  totalPages: 0,
  numberOfElements: 0,
  loading: false,
  error: null,
};

/**
 * Igual que en authorizedVouchersReducer: si el backend devuelve un Slice
 * (sin totalElements), se estima el total con el flag `last` para que la
 * paginacion siga funcionando en vez de quedarse en "0 de 0".
 */
const buildPageState = (payload) => {
  if (Array.isArray(payload)) {
    return {
      comprobantes: payload,
      page: 0,
      size: payload.length,
      totalElements: payload.length,
      totalPages: payload.length > 0 ? 1 : 0,
      numberOfElements: payload.length,
    };
  }

  const pageNumber = payload?.number || 0;
  const pageSize = payload?.size || 15;
  const numberOfElements =
    payload?.numberOfElements ?? (payload?.content ? payload.content.length : 0);

  if (payload && typeof payload.totalElements === "number") {
    return {
      comprobantes: payload?.content || [],
      page: pageNumber,
      size: pageSize,
      totalElements: payload.totalElements,
      totalPages: payload?.totalPages || 0,
      numberOfElements,
    };
  }

  const isLast = payload?.last ?? numberOfElements < pageSize;
  const totalElements = isLast
    ? pageNumber * pageSize + numberOfElements
    : (pageNumber + 1) * pageSize + 1;

  return {
    comprobantes: payload?.content || [],
    page: pageNumber,
    size: pageSize,
    totalElements,
    totalPages: isLast ? pageNumber + 1 : pageNumber + 2,
    numberOfElements,
  };
};

const receivedVouchersReducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVED_VOUCHERS_REQUEST:
      return { ...state, loading: true, error: null };

    case RECEIVED_VOUCHERS_SUCCESS: {
      const pageState = buildPageState(action.payload);
      return { ...state, loading: false, error: null, ...pageState };
    }

    case RECEIVED_VOUCHERS_ERROR:
      return { ...state, loading: false, error: action.payload };

    case RECEIVED_VOUCHERS_CLEAR:
      return initialState;

    default:
      return state;
  }
};

export default receivedVouchersReducer;
